import React, { useEffect, useState } from "react";
import axios from "axios";

import BASE_API_URL from "const";

function Contact(props) {
  const [sendSuccess, setSendSuccess] = useState(false);

  useEffect(() => {
    props.setNavLinks([{ title: "Contact", url: "/contact", icon: "menu-report" }]);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    props.setOverlayVisible((count) => count + 1);

    const form = event.target;
    const formData = new FormData(form);

    await axios
      .post(
        `${BASE_API_URL}/users/contact/`,
        {
          study: formData.get("study"),
          subject: formData.get("subject"),
          message: formData.get("message"),
        },
        { withCredentials: true },
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setSendSuccess(true);
            form.reset();
          }
        },
        (error) => {
          console.error(error);
        },
      );

    props.setOverlayVisible((count) => count - 1);
  };

  return (
    <React.Fragment>
      {sendSuccess && (
        <React.Fragment>
          <div
            id="alertModal"
            className="modal hide fade in"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="false"
            style={{ display: "block" }}
          >
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                ×
              </button>
              <h3 id="alert-modal-title">Contact successfuly sent</h3>
            </div>
            <div className="modal-body">
              <br />
              <p>Thank you for your contact.</p>
              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                onClick={() => setSendSuccess(false)}
                data-dismiss="modal"
                id="alert-modal-cancel"
                aria-hidden="true"
                className="btn small grey align-center right"
              >
                Close
              </button>
            </div>
          </div>
          <div className="modal-backdrop fade in"></div>
        </React.Fragment>
      )}
      <div className="home_header_container_class wide">
        <div className="content">
          <div className="main-form">
            <form id="contact-form" method="post" onSubmit={handleSubmit}>
              <div className="overview">
                <h2>Contact</h2>
              </div>
              <div className="form-group">
                <div style={{ width: "100%", marginTop: "10px" }} />

                <div className="span5" style={{ width: "100%" }}>
                  <div className="row">
                    <div className="label">
                      <label htmlFor="study">Study *</label>
                    </div>
                    <div>
                      <input
                        name="study"
                        id="study"
                        type="text"
                        style={{ width: "83%" }}
                        maxLength={50}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="span5" style={{ width: "100%" }}>
                  <div className="row">
                    <div className="label">
                      <label htmlFor="subject">Subject *</label>
                    </div>
                    <div>
                      <input
                        name="subject"
                        id="subject"
                        type="text"
                        style={{ width: "83%" }}
                        maxLength={100}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="span5"
                  style={{ width: "100%", marginBottom: "15px" }}
                >
                  <div className="row">
                    <div className="label">
                      <label htmlFor="message">Message *</label>
                    </div>
                    <div>
                      <textarea
                        name="message"
                        id="message"
                        rows="20"
                        style={{ width: "83%", border: "1px solid #e6e6e6" }}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-actions" style={{ float: "right" }}>
                <input
                  type="submit"
                  value="Send"
                  className="btn small orange align-center left"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Contact;
